import React from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import styled from "styled-components";

const StyledModal = styled(Modal)`
	background: white;
	padding: 2rem;
	max-width: 500px;
	border-radius: 0.8rem;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	outline: none;

	h2 {
		font-size: 1.6rem;
		margin-bottom: 1.2rem;
	}

	p {
		font-size: 1.2rem;
		margin-bottom: 2rem;
		line-height: 1.5;
	}

	.buttons {
		display: flex;
		justify-content: flex-end;
		gap: 1rem;
	}
`;

const Button = styled.button`
	padding: 0.6rem 1.2rem;
	border-radius: 10rem;
	border: none;
	cursor: pointer;
	font-size: 1rem;
	font-weight: 500;

	${(props) =>
		props.cancel
			? `
		background: #eee;
		color: #333;
	`
			: `
		background: rgb(202, 91, 79);
		color: white;
	`}
`;

const ConfirmDeleteModal = ({ isOpen, onRequestClose, onConfirm, title, message, confirmLabel }) => {
	return (
		<StyledModal
			isOpen={isOpen}
			onRequestClose={onRequestClose}
			ariaHideApp={false}
			shouldCloseOnOverlayClick={true}
			style={{
				overlay: {
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					backgroundColor: "rgba(0, 0, 0, 0.3)", 
					zIndex: 1000, 
				},
				content: {
					inset: "auto", 
					position: "relative",
				},
			}}
		>
			<h2>{title}</h2>
			<p>{message}</p>
			<div className="buttons">
				<Button cancel onClick={onRequestClose}>
					Cancel
				</Button>
				<Button onClick={onConfirm}>{confirmLabel}</Button>
			</div>
		</StyledModal>
	);
};

ConfirmDeleteModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onRequestClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
	message: PropTypes.string.isRequired,
	confirmLabel: PropTypes.string.isRequired,
};

export default ConfirmDeleteModal;
